<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="SDVereine" style="width:1300px;overflow:auto">
            <h2>{{ $t('clubMasterData.Header') }}</h2>
            <div id="Grid">
                <Grid ref="grid"
                      :style="{ height: '640px' }"
                      :data-items="gridDataComputed"
                      :edit-field="'inEdit'"
                      :sortable="true"
                      :sort="sort"
                      :pageable="pageable"
                      :take="take"
                      :skip="skip"
                      :total="total"
                      :loader="loader"
                      @itemchange="itemChange"
                      @datastatechange="dataStateChange"
                      :selected-field="selectedField"
                      @rowclick="onRowClicked"
                      :columns="columns">
                    <grid-toolbar>
                        <kbutton title="Neu" :theme-color="'primary'" @click="onInsert">
                            {{ $t('clubMasterData.ButtonNew') }}
                        </kbutton>
                        <kbutton title="Bearbeiten" :theme-color="'primary'" @click="onEdit" v-bind:disabled="buttonDisabled">
                            {{ $t('clubMasterData.ButtonEdit') }}
                        </kbutton>
                        <kbutton title="Löschen" :theme-color="'primary'" @click="onDelete" v-bind:disabled="buttonDisabled">
                            {{ $t('clubMasterData.ButtonDelete') }}
                        </kbutton>
                    </grid-toolbar>
                    <grid-norecords>{{ $t('clubMasterData.NotificationNoData') }}</grid-norecords>
                </Grid>
            </div>
        </div>
        <br />
        <k-dialog v-if="visibleDialog" :title="$t('clubMasterData.ClubDetails')" :closeIcon="false">
            <div class="k-form k-form-horizontal">
                <div class="k-form-field">
                    <label for="Name" class="k-form-label">{{ $t('clubMasterData.GridColumnHeaderName') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Name'"
                                 v-model="selectedVerein.Name">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Stadt" class="k-form-label">{{ $t('clubMasterData.GridColumnHeaderCity') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Stadt'"
                                 v-model="selectedVerein.Stadt">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Geburtsdatum" class="k-form-label">{{ $t('clubMasterData.GridColumnHeaderPostcode') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'PLZ'"
                                 v-model="selectedVerein.PLZ">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Passwort" class="k-form-label">{{ $t('clubMasterData.GridColumnHeaderNWTUYN') }}</label>
                    <div class="k-form-field-wrap">
                        <k-switch :on-label="$t('clubMasterData.SwitchLabelOn')" :off-label="$t('clubMasterData.SwitchLabelOff')" @change="onChangeNWTUVerein" :checked="checkedNWTUVerein" />
                    </div>
                </div>
            </div>
            <br />
            <div id="Buttons">
                <kbutton @click="onSubmitClick" class="k-button">{{ $t('clubMasterData.ButtonSave') }}</kbutton>&nbsp;&nbsp;&nbsp;
                <kbutton @click="onCancelClick" class="k-button">{{ $t('clubMasterData.ButtonCancel') }}</kbutton>
            </div>
        </k-dialog>
        <k-dialog v-if="visibleDeleteDialog" :title="$t('athletemanagement.NotificationDeleteTitle')" @close="toggleDeleteDialog">
            <p :style="{ margin: '25px', textAlign: 'center' }">{{ $t('clubMasterData.NotificationDelete') }}</p>
            <dialog-actions-bar>
                <kbutton @click='onDeleteData'>{{ $t('clubMasterData.ButtonOK') }}</kbutton>
                <kbutton @click='toggleDeleteDialog'>{{ $t('clubMasterData.ButtonCancel') }}</kbutton>
            </dialog-actions-bar>
        </k-dialog>
        <NotificationGroup :style="{
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                'align-items': 'flex-start'
                }">
            <Fade :appear="success">
                <Notification v-if="success" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('clubMasterData.NotificationSave') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="error">
                <Notification v-if="error" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('clubMasterData.NotificationError') }}</span>
                </Notification>
            </Fade>
        </NotificationGroup>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Input } from '@progress/kendo-vue-inputs';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Switch } from "@progress/kendo-vue-inputs";
    import { toODataString } from "@progress/kendo-data-query";
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import CommandCell from "@/components/CommandCell.vue";
    import config from "@/appdata/config.json";
    import Verein from "../classes/objSDVereine";
    import axios from 'axios';
    import store from '@/store/store.js';

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            'k-input': Input,
            "k-switch": Switch,
            Grid: Grid,
            "grid-toolbar": GridToolbar,
            "grid-norecords": GridNoRecords,
            'combobox': ComboBox,
            custom: CommandCell,
            kbutton: Button,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                baseUrl: config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineManagement",
                init: { method: "GET", accept: "application/json", headers: {} },
                filter: null,
                sort: null,
                pageable: false,
                gridData: [],
                skip: 0,
                take: 10,
                total: 0,
                updatedData: [],
                editID: null,
                selectedField: "selected",
                selectedPrim: 0,
                selectedVerein: null,
                visibleDialog: false,
                neuerVerein: false,
                patchurlVerein: '',
                posturlVerein: '',
                deleteurlVerein: '',
                columns: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 460, title: this.$t('clubMasterData.GridColumnHeaderName') },
                    { field: "stadt", editable: false, width: 150, title: this.$t('clubMasterData.GridColumnHeaderCity') },
                    { field: "plz", editable: false, width: 100, title: this.$t('clubMasterData.GridColumnHeaderPostcode') },
                    { field: "nwtuVerein", editable: false, width: 130, title: this.$t('clubMasterData.GridColumnHeaderNWTUYN') }
                ],
                loader: false,
                success: false,
                error: false,
                visibleDeleteDialog: false,
                checkedNWTUVerein: false
            };
        },
        computed: {
            buttonDisabled() {
                return this.selectedPrim === 0;
            },
            hasItemsInEdit() {
                return this.gridData.filter((p) => p.inEdit).length > 0;
            },
            dataState() {
                return {
                    sort: this.sort,
                    skip: this.skip,
                    take: this.take,
                };
            },
            gridDataComputed() {
                return this.gridData.map((item) => ({ prim: item.prim, name: item.name, stadt: item.stadt, plz: item.plz, nwtuVerein: item.nwtuVerein, selected: (item.prim === this.selectedPrim) }));
            },
        },
        created: function () {
            if (store.istAdmin === true) {
                this.getData();
            }
        },
        methods: {
            onChangeNWTUVerein(e) {
                this.checkedNWTUVerein = e.target.value;
                this.selectedVerein.NWTUVerein = this.checkedNWTUVerein;
            },
            onDeleteData() {
                this.deleteVerein();
                this.neuerVerein = false;
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            toggleDeleteDialog() {
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            saveneuerVerein() {
                const parameters = {
                    "name": this.selectedVerein.Name,
                    "stadt": this.selectedVerein.Stadt,
                    "plz": this.selectedVerein.PLZ,
                    "nwtuVerein": this.selectedVerein.NWTUVerein,
                };
                this.posturlVerein = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineManagement"
                axios.post(this.posturlVerein, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccess();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            saveVerein() {
                const parameters = {
                    "name": this.selectedVerein.Name,
                    "stadt": this.selectedVerein.Stadt,
                    "plz": this.selectedVerein.PLZ,
                    "nwtuVerein": this.selectedVerein.NWTUVerein,
                };
                this.patchurlVerein = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineManagement?prim=" + this.selectedVerein.Prim
                axios.patch(this.patchurlVerein, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccess();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            deleteVerein() {
                this.deleteurlVerein = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineManagement?prim=" + this.selectedVerein.Prim
                axios.delete(this.deleteurlVerein)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccess();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            onInsert() {
                this.selectedVerein = new Verein();
                this.visibleDialog = true;
                this.neuerVerein = true;
            },
            onEdit() {
                this.visibleDialog = true;
                this.neuerVerein = false;

            },
            onDelete() {
                this.visibleDeleteDialog = true;
            },
            onSubmitClick() {
                if (this.neuerVerein === false) {
                    this.saveVerein();
                } else {
                    this.saveneuerVerein();
                }
                this.visibleDialog = false;
                this.neuerVerein = false;

            },
            onCancelClick() {
                this.visibleDialog = false;
                this.neuerVerein = false;
            },
            onRowClicked(event) {
                this.selectedPrim = event.dataItem.prim;
                this.selectedVerein = new Verein();
                this.selectedVerein.Prim = event.dataItem.prim;
                this.selectedVerein.Name = event.dataItem.name;
                this.selectedVerein.Stadt = event.dataItem.stadt;
                this.selectedVerein.PLZ = event.dataItem.plz
                this.selectedVerein.NWTUVerein = event.dataItem.nwtuVerein;
                this.checkedNWTUVerein = event.dataItem.nwtuVerein;
            },
            updateService(action = "", item) {
                const that = this;
                const idIfNeeded =
                    action === "DELETE" || action === "PUT" ? `(${item.prim})` : "";
                const url = this.baseUrl + idIfNeeded;
                const body =
                    action === "POST" || action === "PUT"
                        ? JSON.stringify({
                            ProductID: item.prim,
                            ProductName: item.bezeichnung
                        })
                        : {};
                fetch(url, {
                    method: action,
                    accept: "application/json",
                    headers: {
                        "Content-type": "application/json",
                    },
                    body: body,
                }).then((response) => {
                    if (response.ok) {
                        that.getData();
                    } else {
                        alert("request failed");
                    }
                });
            },
            itemChange: function (e) {
                if (e.dataItem.prim) {
                    let index = this.gridData.findIndex(
                        (p) => p.ProductID === e.dataItem.prim
                    );
                    let updated = Object.assign({}, this.gridData[index], {
                        [e.field]: e.value,
                    });
                    this.gridData.splice(index, 1, updated);
                } else {
                    e.dataItem[e.field] = e.value;
                }
            },
            insert() {
                const dataItem = { inEdit: true };
                this.gridData.splice(0, 0, dataItem);
            },
            edit: function (e) {
                let index = this.gridData.findIndex(
                    (p) => p.ProductID === e.dataItem.ProductID
                );
                let updated = Object.assign({}, this.gridData[index], { inEdit: true });
                this.gridData.splice(index, 1, updated);
            },
            save: function (e) {
                let index = this.gridData.findIndex(
                    (p) => p.ProductID === e.dataItem.ProductID
                );
                let item = this.gridData[index];
                this.updateService(item.ProductID ? "PUT" : "POST", item);
            },
            update(data, item, remove) {
                let updated;
                let index = data.findIndex(
                    (p) => item.ProductID && p.ProductID === item.ProductID
                );
                if (index >= 0) {
                    updated = Object.assign({}, item);
                    data[index] = updated;
                } else {
                    let id = 1;
                    this.updatedData.forEach((p) => {
                        if (p.ProductID) {
                            id = Math.max(p.ProductID + 1, id);
                        }
                    });
                    updated = Object.assign({}, item, { ProductID: id });
                    data.unshift(updated);
                    index = 0;
                }

                if (remove) {
                    data = data.splice(index, 1);
                }
                return data[index];
            },
            cancel(e) {
                if (e.dataItem.ProductID) {
                    let index = this.gridData.findIndex(
                        (p) => p.ProductID === e.dataItem.ProductID
                    );
                    let updateDataIndex = this.updatedData.findIndex(
                        (p) => p.ProductID === e.dataItem.ProductID
                    );
                    let updated = Object.assign(this.updatedData[updateDataIndex], {
                        inEdit: undefined,
                    });
                    this.gridData.splice(index, 1, updated);
                } else {
                    let index = this.gridData.findIndex(
                        (p) => JSON.stringify(e.dataItem) === JSON.stringify(p)
                    );

                    this.gridData.splice(index, 1);
                }
            },
            remove(e) {
                e.dataItem.inEdit = undefined;
                this.updateService("DELETE", e.dataItem);
            },
            cancelChanges() {
                this.getData();
            },
            getData: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrl + "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.total = total;
                        that.updatedData = [].concat(data);
                        that.gridData = data;
                        this.loader = false;
                    });
            },
            createAppState: function (dataState) {
                this.take = dataState.take;
                this.skip = dataState.skip;
                this.filter = dataState.filter;
                this.sort = dataState.sort;
                this.getData();
            },
            dataStateChange: function (event) {
                this.createAppState(event.data);
            },
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            }
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>